/* eslint-disable camelcase */
import { extend, localize } from 'vee-validate'
import { max, min, required, min_value, max_value } from 'vee-validate/dist/rules'
import pt_BR from 'vee-validate/locale/pt_BR'
import _ from 'lodash'
import moment from 'moment'
import store from '@/store'

const SIGLA_ESTADO = store.state.userInterface.dadosEstado.SIGLA_ESTADO

localize('pt_BR', pt_BR)

const carregarExtends = () => {
  extend('required', { ...required, message: 'Campo obrigatório.' })
  extend('min_value', {
    ...min_value,
    message: (field, params, value) => {
      return 'O valor do campo deve ser no mínimo ' + params['min'] + '.'
    }
  })
  extend('max_value', {
    ...max_value,
    message: (field, params) => {
      return 'O valor do campo deve ser no máximo ' + params['max'] + '.'
    }
  })

  extend('cpf_cnpj', {
    validate (value) {
      return isValidCPF(value) || isValidCNPJ(value)
    },
    message: 'CPF/CNPJ inválido',
    computesRequired: true
  })

  extend('cpf', {
    validate (value) {
      return isValidCPF(value)
    },
    message: 'CPF inválido',
    computesRequired: true
  })

  extend('cnpj', {
    validate (value) {
      return isValidCNPJ(value)
    },
    message: 'CNPJ inválido',
    computesRequired: true
  })

  extend('max', {
    ...max,
    message: (field, params) => {
      return 'Limite máximo de ' + params.length + ' caracteres.'
    }
  })

  extend('min', {
    ...min,
    message: (field, params) => {
      return 'Limite mínimo de ' + params.length + ' caracteres.'
    }
  })

  extend('min_painel', {
    ...min,
    message: (field, params) => {
      return 'Nome do painel deve conter no mínimo ' + params.length + ' caracteres.'
    }
  })

  extend('telefone', {
    validate (value) {
      return isValidTelefone(value)
    },
    message: 'Número de telefone inválido',
    computesRequired: true
  })

  extend('email', {
    validate (value) {
      return isValidEmail(value)
    },
    message: 'E-mail inválido',
    computesRequired: true
  })

  extend('numeroProcessoFisico', {
    validate (value) {
      return isValidnNumeroProcessoFisico(value)
    },
    message: 'Número do processo inválido',
    computesRequired: true
  })

  extend('car', {
    validate (value) {
      return isValidCar(value)
    },
    message: 'Número do CAR inválido',
    computesRequired: true
  })

  extend('max', {
    ...max,
    message: (field, params) => {
      return 'Limite máximo de ' + params.length + ' caracteres.'
    }
  })

  extend('email_confirmation', {
    params: ['target'],
    validate (value, { target }) {
      return value === target
    },
    message: 'Os e-mails informados devem ser iguais'
  })

  extend('password_confirmation', {
    params: ['target'],
    validate (value, { target }) {
      return value === target
    },
    message: 'As senhas informadas devem ser iguais'
  })

  extend('min', {
    ...min,
    message: (field, params) => {
      return 'Limite mínimo de ' + params.length + ' caracteres.'
    }
  })

  extend('min_value', {
    validate (value, { minValue }) {
      return value >= minValue
    },
    message: 'O valor deve ser maior que {minValue} ',
    params: ['minValue'],
    computesRequired: true
  })

  extend('apenasLetras', {
    validate (value) {
      return isOnlyLetters(value)
    },
    message: 'O {_field_} deve ter apenas letras',
    computesRequired: true
  })

  extend('apenasNumeros', {
    validate (value) {
      return isOnlyNumbers(value)
    },
    message: 'O {_field_} deve ter apenas números',
    computesRequired: true
  })

  /* Validação de documentos obrigatório dos cadastro */
  let errorMessage = ''
  extend('documentosObrigatorios', {
    validate (values) {
      if (!values) {
        return false
      }

      const { documentos, documentosObrigatorios } = values

      const errors = []
      errorMessage = '\n\n'

      for (let i = 0; i < documentosObrigatorios.length; i++) {
        const docFound = _.find(documentos, item => documentosObrigatorios[i].codigo.includes(item.tipoDocumento.codigo))

        if (!docFound) {
          errors.push(documentosObrigatorios[i].descricao + ' é obrigatório.')
          errorMessage += '  - ' + documentosObrigatorios[i].descricao + ' é obrigatório \n\n'
        }
      }

      return errors.length > 0 ? errorMessage : true
    }
  })

  extend('peloMenosUmDocumentoObrigatorio', {
    validate (values) {
      const { documentos, tiposDocumentos } = values

      const errors = []
      errorMessage = '\n\n Pelo menos um dos documentos a seguir é obrigatório: \n\n'

      if (documentos.length === 0) {
        errors.push('Pelo menos um dos documentos é obrigatório.')
        tiposDocumentos.forEach(td => {
          errorMessage += '  - ' + td.descricao + ' \n\n'
        })
      } else {
        let docFound

        for (let i = 0; i < tiposDocumentos.length; i++) {
          if (!docFound) {
            docFound = _.find(documentos, item => tiposDocumentos[i].codigo.includes(item.tipoDocumento.codigo))
          }
        }

        if (!docFound) {
          errors.push('Pelo menos um documento é obrigatório.')

          tiposDocumentos.forEach(td => {
            errorMessage += '  - ' + td.descricao + ' \n\n'
          })
        }
      }
      return errors.length > 0 ? errorMessage : true
    }
  })

  extend('documentosObrigatoriosRetificacao', {

    validate (values) {
      if (!values) {
        return false
      }
      const { documentos, documentosObrigatorios } = values

      let docsParaValidacao = documentosObrigatorios.filter(doc => {
        const arrayDocsPJNaoObriatorio = ['CPF_PROCURADOR', 'IDENTIFICACAO_PROCURADOR', 'OUTROS_INTERESSADO_PJ', 'PROCURACAO_PUBLICA']
        if (arrayDocsPJNaoObriatorio.includes(doc.codigo)) {
          doc.showValidacao = false
        }
        if ('showValidacao' in doc) {
          return doc.showValidacao === true
        }
        return true
      })

      docsParaValidacao = docsParaValidacao.filter(doc => !doc.codigo.includes('OUTROS'))

      const errors = []
      errorMessage = '\n\n'

      documentos.forEach(doc => {
        if (doc.tipo.codigo === 'ATESTADO_OBITO_INTERESSADO') {
          doc.tipo.codigo = 'ATESTADO_OBITO_CONJUGE'
        } else if (doc.tipo.codigo === 'IDENTIFICACAO_SOCIO') {
          doc.tipo.codigo = 'IDENTIFICACAO_SR'
        } else if (doc.tipo.codigo === 'CPF_SOCIO') {
          doc.tipo.codigo = 'CPF_SR'
        }
      })

      for (let i = 0; i < docsParaValidacao.length; i++) {
        const docFound = _.find(documentos, item => docsParaValidacao[i].codigo.includes(item.tipo.codigo))

        if (!docFound) {
          errors.push(docsParaValidacao[i].descricao + ' é obrigatório.')
          errorMessage += '  - ' + docsParaValidacao[i].descricao + ' é obrigatório \n\n'
        }
      }

      return errors.length > 0 ? errorMessage : true
    }
  })

  extend('dateAfterToday', {
    message: `A data selecionada deve ser superior a ${moment().format('DD/MM/YYYY')}.`,
    validate: (value) => {
      return moment(value).isAfter(moment())
    }
  })

  extend('notZero', {
    message: 'O valor deve ser maior que zero',
    validate: value => value > 0
  })

  extend('perfis_setor_unique', {
    validate: (value) => {
      return perfisHasSingleSetor(value)
    },
    message: 'Não é possível inserir dois perfis de um mesmo setor.'
  })

  extend('perfis_setor_unique_reurb', {
    validate: (value) => {
      return perfisHasSingleSetorReurb(value)
    },
    message: 'Não é possível ter o cadastrante reurb externo e interno vinculados a um mesmo usuário.'
  })

  extend('perfis_externo', {
    validate: (value) => {
      return hasSetorExterno(value)
    },
    message: 'Não é possível ter um perfil externo e um perfil interno vinculados a um mesmo usuário.'
  })

  extend('hasTelefone', {
    message: 'Campo obrigatório',
    validate (values) {
      const { telefones } = values

      if (!telefones || !telefones.length || telefones.length <= 0) {
        return false
      }

      return true
    },
    computesRequired: true
  })

  extend('hasEmail', {
    message: 'Campo obrigatório',
    validate (values) {
      const { emails } = values

      if (!emails || !emails.length || emails.length <= 0) {
        return false
      }

      return true
    },
    computesRequired: true
  })

  extend('numeroDae', {
    validate: (value) => {
      return value?.length > 44 && value?.length <= 60
    },
    message: 'O Número do DAE precisa conter de 44 a 60 caracteres.'
  })

  extend('areaReservaLegal', {
    validate: (value) => {
      return parseFloat(value.toString().replace(',', '.')) !== 0.0000
    },
    message: 'O Campo é obrigatório.'
  })

  extend('percentualAreaReservaLegal', {
    validate: (value) => {
      return parseFloat(value.toString().replace(',', '.')) !== 0.00
    },
    message: 'O Campo é obrigatório.'
  })

  extend('documentosProdutividade', {
    validate: (value) => {
      return value?.documentos?.length > 0
    },
    message: 'O Campo é obrigatório.'
  })

  extend('termo', {
    validate: (value) => {
      return value
    },
    message: 'A confirmação do termo de aceite é obrigatória.'
  })

  extend('validaDestinacaoImovel', {
    validate: value => {
      return value
    },
    message: 'Deve ser informado no mínimo uma destinação para o imóvel.'
  })

  extend('reciboCar', {
    validate: value => { return (isValidReciboCar(value)) },
    message: 'Número do recibo inválido.'
  })

  extend('numeroRecibo', {
    validate (value) {
      return isValidNumeroRecibo(value)
    },
    message: 'Número de recibo inválido',
    computesRequired: true
  })
}

function isValidReciboCar (reciboCarFull) {
  if (reciboCarFull === null || reciboCarFull === undefined) {
    return false
  }
  var reciboCar = reciboCarFull.toString().replace(/[-_./]/g, '')
  if (reciboCar.length !== 41) {
    return false
  }
  const res = reciboCar.split('')
  if (res[0] !== 'P' || res[1] !== 'A') {
    return false
  }
  return true
}

function isValidnNumeroProcessoFisico (numeroProcesso) {
  var re = /[\d]{4}["/"][\d]{1,6}/
  return re.test(String(numeroProcesso))
}

function isValidEmail (email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function isValidCar (car) {
  if (car === null || car === undefined) {
    return false
  }

  var reciboCar = car.toString().replace(/[-_./]/g, '')
  if (reciboCar.length !== 41) {
    return false
  }

  const res = reciboCar.split('')
  const letrasSigla = SIGLA_ESTADO.split('')

  if (res[0] !== letrasSigla[0] || res[1] !== letrasSigla[1]) {
    return false
  }

  return true
}

const setoresPermitidosMaisDeUmPerfil = [
  'PREFEITURA',
  'RELATORIOS',
  'OUTRO',
  'BANCO_DADOS',
  'REURB'
]

/** Perfis de aplicativo REURB interno e externo não podem coexistir no mesmo setor REURB. */
function perfisReurbAplicativoExclusivos (perfis) {
  const codigosNoSetorReurb = perfis
    .filter(perfil => perfil.setor != null && perfil.setor.codigo === 'REURB')
    .map(perfil => perfil.codigo)
    .filter(Boolean)
  const temInterno = codigosNoSetorReurb.includes('APLICATIVO_REURB')
  const temExterno = codigosNoSetorReurb.includes('APLICATIVO_REURB_EXTERNO')
  return !(temInterno && temExterno)
}

function perfisHasSingleSetorReurb (perfis) {
  if (!perfisReurbAplicativoExclusivos(perfis)) {
    return false
  }
  return true
}

function perfisHasSingleSetor (perfis) {
  const codigosSetor = perfis.map(perfil =>
    perfil.setor != null ? perfil.setor.codigo : '')

  for (let i = 0; i < codigosSetor.length; i++) {
    for (let j = i + 1; j < codigosSetor.length; j++) {
      if ((codigosSetor[i] === codigosSetor[j]) && !setoresPermitidosMaisDeUmPerfil.includes(codigosSetor[i])) {
        return false
      }
    }
  }
  return true
}

function hasSetorExterno (perfis) {
  const perfisAux = SIGLA_ESTADO === 'BA' ? perfis.filter(perfil => perfil.codigo !== 'TECNICO_DE_CAMPO') : perfis
  const codigosSetor = perfisAux.map(perfil =>
    perfil.setor != null ? perfil.setor.codigo : '')

  const codigoPerfil = perfisAux.map(perfil =>
    perfil.codigo != null ? perfil.codigo : '')
  const hasExterno = codigosSetor.includes('EXTERNO') || codigosSetor.includes('AGENDAMENTO') || codigosSetor.includes('PARCEIRO') || codigosSetor.includes('CREDENCIADOS') || codigoPerfil.includes('VISTORIA_EXTERNO') || codigoPerfil.includes('RECEPTOR_EXTERNO')

  for (let i = 0; i < codigosSetor.length; i++) {
    if (codigosSetor[i] !== 'EXTERNO' && codigosSetor[i] !== 'AGENDAMENTO' && codigosSetor[i] !== 'PARCEIRO' && codigosSetor[i] !== 'CREDENCIADOS' && codigoPerfil[i] !== 'VISTORIA_EXTERNO' && codigoPerfil[i] !== 'RECEPTOR_EXTERNO' && hasExterno) {
      return false
    }
  }
  return true
}

function isOnlyLetters (string) {
  var re = /^[a-zA-Z\u00C0-\u00FF\s]*$/
  return re.test(string)
}

function isOnlyNumbers (number) {
  var re = /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/g
  return re.test(number)
}

// Validação do CPF
function isValidCPF (cpf) {
  if (cpf === undefined || cpf === null) return false

  if ((cpf = cpf.replace(/[^\d]/g, '')).length !== 11) return false

  const cpfInvalidos = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999'
  ]

  if (cpfInvalidos.indexOf(cpf) > -1) return false

  let r,
    i
  let s = 0
  for (i = 1; i <= 9; i++) s += parseInt(cpf[i - 1]) * (11 - i)
  r = (s * 10) % 11
  if (r === 10 || r === 11) r = 0
  if (r !== parseInt(cpf[9])) return false
  s = 0
  for (i = 1; i <= 10; i++) s += parseInt(cpf[i - 1]) * (12 - i)
  r = (s * 10) % 11

  if (r === 10 || r === 11) r = 0

  if (r !== parseInt(cpf[10])) return false

  return true
}

function isValidCNPJ (cnpjFull) {
  if (cnpjFull === null || cnpjFull === undefined) {
    return false
  }
  var cnpj = cnpjFull.toString().replace(/[-_./]/g, '')

  if (cnpj.length !== 14) {
    return false
  }

  let i
  const c = cnpj.substr(0, 12)
  const dv = cnpj.substr(12, 2)
  let d1 = 0

  for (i = 0; i < 12; i++) {
    d1 += c.charAt(11 - i) * (2 + (i % 8))
  }

  if (d1 === 0) {
    return false
  }

  d1 = 11 - (d1 % 11)

  if (d1 > 9) {
    d1 = 0
  }

  if (parseInt(dv.charAt(0)) !== d1) {
    return false
  }

  d1 *= 2

  for (i = 0; i < 12; i++) {
    d1 += c.charAt(11 - i) * (2 + ((i + 1) % 8))
  }

  d1 = 11 - (d1 % 11)

  if (d1 > 9) {
    d1 = 0
  }

  if (parseInt(dv.charAt(1)) !== d1) {
    return false
  }

  return true
}

function isValidTelefone (telefone) {
  // (##) #####-####
  const regexFixo = /[(]\d\d[)] \d\d\d\d[-]\d\d\d\d/g
  if (telefone.match(regexFixo)) {
    return true
  }
  const regexCelular = /[(]\d\d[)] \d\d\d\d\d[-]\d\d\d\d/g
  if (telefone.match(regexCelular)) {
    return true
  }
  return false
}

function isValidNumeroRecibo (numeroRecibo) {
  return numeroRecibo.match(/^[A-Z]{3}-[A-Z0-9]{6}-[A-Z0-9]{7}-\d{4}$/)
}

export default carregarExtends



// WEBPACK FOOTER //
// ./src/utils/veeValidate.js